/**
 * Account-history list date. Pending sends use initiated time;
 * delivered/read messages use completed (read) time.
 */
export const getTransactionListingDate = (tx: {
  dateListed?: string;
  dateCompleted?: string;
  dateInitiated?: string;
  date?: string;
}): string =>
  tx.dateListed || tx.dateCompleted || tx.dateInitiated || tx.date || '';

export const getTransactionListingTime = (tx: {
  dateListed?: string;
  dateCompleted?: string;
  dateInitiated?: string;
  date?: string;
}): number => {
  const raw = getTransactionListingDate(tx);
  const parsed = raw ? new Date(raw).getTime() : 0;
  return Number.isFinite(parsed) ? parsed : 0;
};
